import { call, put } from 'redux-saga/effects'
import { AlertsService } from 'services/alerts.service'
import { setAlert } from './Alert.actions'

export function* fetchUnseenAlertsSaga() {
  const alertsService = new AlertsService()
  try {
    const unseenAlerts = yield call(alertsService.getUnseenAlerts)
    if (Array.isArray(unseenAlerts) && unseenAlerts.length > 0) {
      yield put(setAlert(unseenAlerts[0]))
    } else {
      yield put(setAlert(null))
    }
  } catch (error) {
    console.error('Error fetching unseen alerts:', error)
    yield put(setAlert(null))
  }
}
